<template>
  <div class="a-vs-header--main-slider">
    <div class="slides-container">
      <transition name="slide">
        <div class="slide main-results-slide" v-if="showResult">
          <div class="a-vs--header-video-results">
            <h3 class="a-vs--header-label">{{ $t("results") }}</h3>
            <div class="a-vs--hvr-wrap">
              <div class="a-vs-b--pair">
                <div class="a-vs-c--host">
                  <img :src="homeTeamLogo" :alt="homeTeamShort" />
                  <span>{{ homeTeam }}</span>
                </div>
                <div class="a-vs-b--result">
                  <span>{{ homeScore }} : {{ awayScore }}</span>
                </div>
                <div class="a-vs-c--guest">
                  <img :src="awayTeamLogo" :alt="awayTeamShort" />
                  <span>{{ awayTeam }}</span>
                </div>
              </div>
              <div class="a-vs-b--results-table">
                <ul>
                  <li>{{ $t("final_outcome") }}</li>
                  <li>{{ $t("halftime_outcome") }}</li>
                  <li>{{ $t("more_less_goals") }}</li>
                  <li>{{ $t("correct_result") }}</li>
                </ul>
                <ul>
                  <li>{{ finalOutcome }}</li>
                  <li>({{ homeHalfTimeScore }} : {{ awayHalfTimeScore }})</li>
                  <li>{{ homeScore + awayScore }} {{ $t("goals") }}</li>
                  <li>{{ homeScore }} : {{ awayScore }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    awayTeam: {
      type: String
    },
    awayTeamLogo: {
      type: String
    },
    awayTeamShort: {
      type: String
    },
    homeTeam: {
      type: String
    },
    homeTeamLogo: {
      type: String
    },
    homeTeamShort: {
      type: String
    },
    homeScore: {
      type: Number
    },
    awayScore: {
      type: Number
    },
    homeHalfTimeScore: {
      type: Number
    },
    awayHalfTimeScore: {
      type: Number
    }
  },
  computed: {
    showResult: function () {
      return this.homeTeam && this.awayTeam
    },
    finalOutcome: function () {
      if (this.homeScore === this.awayScore) {
        return 'X'
      } else if (this.homeScore > this.awayScore) {
        return '1'
      } else {
        return '2'
      }
    }
  }
}
</script>
